import Vue from 'vue'
import Router from 'vue-router'
import Projects from '@/components/Projects'
// import Project from '@/components/Project'
// import Current from '@/components/Current'
// import Info from '@/components/Info'
// import News from '@/components/News'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/current'
    },
    {
      path: '/current',
      name: 'Current',
      component: Projects,
      props: true
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
      props: true
    },
    {
      path: '/info',
      name: 'Info',
      component: Projects
      // component: Info
    },
    // {
    //   path: '/news',
    //   name: 'News',
    //   component: News
    // },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    let position = { x: 0, y: 0 }
    // Keep scroll position when using browser buttons
    if (savedPosition) {
      position = savedPosition
    }
    // Workaround for transitions scrolling to the top of the page
    // However, there are still some problems being fixed by the vue team
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(position)
      }, 1000)
    })

    // return {}
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({ left: 0, top: 0 })
    //   }, 500)
    // })
    // return savedPosition
    // if (to.name === 'Projects') {
    //   return false
    // }
    // else if (to.name === 'Current') {
    //   return false
    // }
    //   // return {
    //   //   el: '#projects',
    //   //   top: -10
    //   // }
    // if (savedPosition) {
    //   return savedPosition
    // }
    // return {}
    // else {
    // return { 
    //   x: 0, y: 0,
    //   behavior: 'smooth'
    // }
    // }
    // else if (to.name === 'Projects') {
    //   return { x: 0, y: 0 }
    // }
    // {
    //   return { x: 0, y: 1000 }
    // }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js